define("ember-functions-as-helper-polyfill/-private/local-glimmer-interfaces-types", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
});